export default __webpack_public_path__ + "static/media/about-team-kaylyn-sorrentino.ded2625b.png";